module.exports = __webpack_public_path__ + "img/logo_text.49a91d7f.svg";